import DateFnsUtils from "@date-io/date-fns";
import {Grid, IconButton} from "@material-ui/core";
import {DatePicker as DatePickerWidget} from "@material-ui/pickers";
import Translate from "../utils/utils";
import {MuiPickersUtilsProvider} from "../styles/config";
import React, {useState} from "react";
import enLocale from "date-fns/locale/en-US";
import deLocale from "date-fns/locale/de";
import nlLocale from "date-fns/locale/nl";
import itLocale from "date-fns/locale/it";
import esLocale from "date-fns/locale/es";
import moment from "moment";
import {useSelector} from "react-redux";
import {getLocaleFromLanguageId} from "../../_metronic/i18n/I18nProvider";
import {injectIntl} from "react-intl";
import CloseIcon from "@material-ui/icons/Close";

const DatePicker = (props) => {

    const {handleDateChange, dateTerm, label = 'Date'} = props;
    const [date, setDate] = useState(dateTerm);
    const dateFormat = 'DD-MM-YYYY';
    let locale = 'en';
    const user = useSelector(store => store.auth.user);
    if (user) {
        locale = getLocaleFromLanguageId(user.language_id);
    }

    const onDateChange = (value) => {
        const date = moment(Date.parse(value)).format(dateFormat);
        setDate(date);
        handleDateChange(date);
    };

    const parseDate = (date) => {
        return moment(date, dateFormat).toDate();
    };


    const localeMap = {
        en: enLocale,
        de: deLocale,
        nl: nlLocale,
        it: itLocale,
        es: esLocale,
    };


    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[locale]}>
            <Grid container className="col-lg-6 form-control" justifyContent="space-around">
                <DatePickerWidget
                    margin="none"
                    variant="none"
                    // placeholder={intl.formatMessage({
                    //     id: "TABLE.DATE"
                    // })}
                    placeholder={label}
                    value={date ? parseDate(date) : null}
                    onChange={onDateChange}
                    format="dd-MM-yyyy"
                    InputProps={{
                        disableUnderline: true,
                        endAdornment: (
                            <CloseIcon onClick={() => setDate(null)}/>
                        )
                    }}
                    okLabel={<Translate id={"DATEPICKER.OK"}/>}
                    clearLabel={<Translate id={"DATEPICKER.CLEAR"}/>}
                    cancelLabel={<Translate id={"DATEPICKER.CANCEL"}/>}
                    locale={locale}
                />
            </Grid>
        </MuiPickersUtilsProvider>
    );
};

export default injectIntl(DatePicker);
